import { selector } from 'recoil';
import { PartySubTypeEnum } from '@zurich/api/party';
import { allValid, alwaysValidValidationSelector } from '@zurich/common/recoil';
import { localPartyBusinessNameValidationSelector, localPartyFirstNameValidationSelector, localPartyLastNameValidationSelector, localPartyLegalFormNotRequiredValidationSelector, localPartyOrganizationNameValidationSelector, localPartyOrganizationTypeValidationSelector, localPartySubTypeSelector, } from '../';
export const createPreviousInsurerPartyFormValidationSelector = selector({
    key: 'validation/local/previousInsurerPartyForm',
    get: ({ get }) => {
        const partySubType = get(localPartySubTypeSelector);
        if (partySubType === PartySubTypeEnum.UNTERNEHMEN ||
            partySubType === PartySubTypeEnum.VEREIN) {
            return allValid({
                partyLegalForm: get(localPartyLegalFormNotRequiredValidationSelector),
                partyOrganizationName: get(localPartyOrganizationNameValidationSelector),
            });
        }
        return allValid({
            partyFirstName: get(localPartyFirstNameValidationSelector),
            partyLastName: get(localPartyLastNameValidationSelector),
            partyLegalForm: partySubType === PartySubTypeEnum.PRIVATPERSON
                ? get(alwaysValidValidationSelector)
                : get(localPartyLegalFormNotRequiredValidationSelector),
            partyBusinessName: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                ? get(localPartyBusinessNameValidationSelector)
                : get(alwaysValidValidationSelector),
            partyOrganizationType: partySubType === PartySubTypeEnum.EINZELUNTERNEHMER
                ? get(localPartyOrganizationTypeValidationSelector)
                : get(alwaysValidValidationSelector),
        });
    },
});
